import type {
  DocumentSectionSpec,
  DocumentTemplateParseResponse,
} from '@/entities/templates';

import { generateSectionCode } from './codeGenerator';

export const hasParsedSections = (
  result: DocumentTemplateParseResponse,
): boolean => Boolean(result.sections && result.sections.length > 0);

export const mapParsedSections = (
  sections: DocumentTemplateParseResponse['sections'],
): DocumentSectionSpec[] =>
  sections.map((section) => ({
    code: section.code || generateSectionCode(),
    title: section.title || '',
    category: section.category,
    editor_type: section.editor_type ?? 'section',
    instructions: section.instructions ?? undefined,
    options:
      section.options && section.options.length > 0
        ? section.options
        : undefined,
    type: section.type,
    processing_type: section.processing_type ?? 'STANDARD',
    template_type: section.template_type,
    required: section.required,
  }));
